import { metrikaID } from "./const";

export function reachGoal(target, cb) {
  if (!target) {
    return;
  }

  if (!window.ym) {
    return;
  }

  // console.log("METRIKA", Date.now(), target);

  if (cb) {
    window.ym(metrikaID, "reachGoal", target, () => {
      cb();
    });
  } else {
    window.ym(metrikaID, "reachGoal", target);
  }
}
